/** Persian labels for Phase 4 money states (admin). Raw codes remain available as technical detail. */
export const ADJ_OP: Record<string, string> = {
  CREDIT: 'افزایش موجودی',
  DEBIT: 'کاهش موجودی',
  RESERVE: 'مسدودسازی (رزرو)',
  RELEASE: 'آزادسازی مسدودی',
  REVERSAL: 'برگشت اصلاحیه',
};

export const DEPOSIT_METHOD: Record<string, string> = {
  CARD_TO_CARD: 'کارت به کارت',
  ACCOUNT_TO_ACCOUNT: 'حساب به حساب',
  POL: 'پل',
  SHEBA_TRANSFER: 'انتقال با شبا',
};

export const DEPOSIT_STATUS: Record<
  string,
  { label: string; tone: 'positive' | 'negative' | 'accent' | 'neutral' }
> = {
  SUBMITTED: { label: 'در انتظار وجه', tone: 'accent' },
  UNDER_REVIEW: { label: 'نیازمند بررسی', tone: 'accent' },
  APPROVED_CREDITED: { label: 'واریز شد', tone: 'positive' },
  REJECTED: { label: 'ردشده', tone: 'negative' },
  CANCELLED: { label: 'لغوشده', tone: 'neutral' },
};

export const WITHDRAWAL_STATUS: Record<
  string,
  { label: string; tone: 'positive' | 'negative' | 'accent' | 'neutral' }
> = {
  PROCESSING: { label: 'در حال انجام', tone: 'accent' },
  SECURITY_HOLD: { label: 'توقف امنیتی', tone: 'negative' },
  SETTLEMENT_UNCERTAIN: { label: 'تسویه نامشخص', tone: 'negative' },
  COMPLETED: { label: 'انجام شد', tone: 'positive' },
  REJECTED_REFUNDED: { label: 'رد و بازگشت به کیف', tone: 'neutral' },
};

export const WITHDRAWAL_ACTION: Record<string, string> = {
  COMPLETE: 'ثبت انجام تسویه',
  REJECT: 'رد و بازگرداندن مبلغ',
  HOLD: 'توقف امنیتی',
  RESUME: 'ادامه‌ی پردازش',
  MARK_UNCERTAIN: 'علامت تسویه‌ی نامشخص',
};

export const RAIL: Record<string, string> = {
  INTERNAL: 'داخلی (همان بانک)',
  POL: 'پل',
  PAYA: 'پایا',
  SATNA: 'ساتنا',
  CARD: 'کارت به کارت',
  OTHER: 'سایر',
};

export const EVENT_STATUS: Record<
  string,
  { label: string; tone: 'positive' | 'negative' | 'accent' | 'neutral' }
> = {
  UNMATCHED: { label: 'تطبیق‌نیافته', tone: 'accent' },
  MATCHED: { label: 'تطبیق و واریز شد', tone: 'positive' },
  NEEDS_REVIEW: { label: 'نیازمند بررسی', tone: 'negative' },
  RETURN_REQUIRED: { label: 'نیازمند بازگشت وجه', tone: 'negative' },
};

/** OPEN-31 review reasons — why the matcher refused to auto-credit. */
export const CASE_REASON: Record<string, string> = {
  NO_MATCHING_INTENT: 'درخواست واریز منطبقی پیدا نشد',
  SOURCE_NOT_REPORTED: 'بانک مبدأ را گزارش نکرده است',
  SOURCE_NOT_OWNED_BY_INTENT: 'مبدأ با کارت/حساب درخواست یکی نیست',
  CHANNEL_MISMATCH: 'روش انتقال با درخواست سازگار نیست',
  MULTIPLE_CANDIDATES: 'بیش از یک درخواست منطبق',
  CONFLICTING_EVIDENCE: 'شواهد بانکی متعارض',
  CUSTOMER_NOT_ELIGIBLE: 'کاربر اکنون واجد شرایط نیست',
  SOURCE_INSTRUMENT_NOT_USABLE: 'کارت/حساب مبدأ قابل استفاده نیست',
  CARD_DAILY_LIMIT: 'سقف روزانه‌ی کارت مبدأ',
  DUPLICATE_EVENT_CONFLICT: 'رویداد تکراری با محتوای متفاوت',
};

export const CASE_KIND: Record<string, string> = {
  DEPOSIT_EVIDENCE_REVIEW: 'بررسی شاهد واریز',
  WITHDRAWAL_SETTLEMENT_UNCERTAIN: 'تسویه‌ی نامشخص برداشت',
  LEDGER_INTEGRITY: 'یکپارچگی دفتر کل',
};

export const RESOLUTION: Record<string, string> = {
  CREDIT: 'واریز به کیف کاربر',
  REJECT_AND_RETURN: 'رد و بازگشت وجه به مبدأ',
  DISMISS: 'بستن بدون اثر مالی',
};

export const RECON_CHECK: Record<string, string> = {
  JOURNAL_BALANCED: 'تراز بودن هر سند (به تفکیک دارایی)',
  JOURNAL_MIN_POSTINGS: 'حداقل دو ردیف در هر سند',
  POSTING_ASSET_SCALE: 'دقت اعشار مطابق دارایی',
  PROJECTION_MATCHES_LEDGER: 'موجودی‌ها = جمع ردیف‌های دفتر',
  USER_BALANCES_NON_NEGATIVE: 'منفی نبودن موجودی کاربران',
  RESERVED_EQUALS_OPEN_RESERVATIONS: 'رزرو = جمع رزروهای باز',
  RESERVATION_TRANSACTIONS: 'سند رزرو و آزادسازی هر رزرو',
  DEPOSITS_CREDITED_EXACTLY_ONCE: 'هر واریز دقیقاً یک‌بار',
  DEPOSIT_EVIDENCE_LINK: 'هر واریز دارای شاهد بانکی',
  WITHDRAWAL_LIFECYCLE: 'چرخه‌ی سند هر برداشت',
  JOURNAL_SOURCE_RESOLVES: 'مبدأ هر سند موجود است',
  REVERSAL_IS_EXACT_NEGATION: 'برگشت = قرینه‌ی دقیق سند اصلی',
  IDEMPOTENCY_SINGLE_EFFECT: 'هر کلید تکرار، یک اثر',
};

export const RUN_STATUS: Record<
  string,
  { label: string; tone: 'positive' | 'negative' | 'accent' | 'neutral' }
> = {
  RUNNING: { label: 'در حال اجرا', tone: 'accent' },
  CLEAN: { label: 'بدون مغایرت', tone: 'positive' },
  MISMATCH: { label: 'مغایرت', tone: 'negative' },
  FAILED: { label: 'اجرا ناموفق', tone: 'negative' },
};

export const ACCOUNT_CLASS: Record<string, string> = {
  USER_AVAILABLE: 'کاربر · قابل استفاده',
  USER_RESERVED: 'کاربر · رزروشده',
  HOUSE_TREASURY: 'خزانه‌ی هوپکس',
  HOUSE_FEE: 'کارمزد هوپکس',
  HOUSE_ADJUSTMENT: 'حساب اصلاحات',
  EXT_FIAT_IN: 'ورودی بانکی (تسویه)',
  EXT_FIAT_OUT: 'خروجی بانکی (تسویه)',
  EXT_CHAIN_IN: 'ورودی زنجیره',
  EXT_CHAIN_OUT: 'خروجی زنجیره',
};

export const TX_TYPE: Record<string, string> = {
  TOMAN_DEPOSIT_CREDIT: 'واریز تومان',
  TOMAN_WITHDRAWAL_RESERVE: 'رزرو برداشت تومان',
  TOMAN_WITHDRAWAL_COMPLETE: 'تسویه‌ی برداشت تومان',
  TOMAN_WITHDRAWAL_REFUND: 'بازگشت برداشت تومان',
  ADMIN_CREDIT: 'افزایش موجودی (مدیر)',
  ADMIN_DEBIT: 'کاهش موجودی (مدیر)',
  ADMIN_RESERVE: 'مسدودسازی (مدیر)',
  ADMIN_RELEASE: 'آزادسازی (مدیر)',
  ADMIN_REVERSAL: 'برگشت اصلاحیه (مدیر)',
};

/** IRT is the ledger code of «تومان»; the UI unit for formatAmount is TOMAN. */
export const unitOf = (asset: string): string => (asset === 'IRT' ? 'TOMAN' : asset);
export const assetName = (asset: string): string => (asset === 'IRT' ? 'تومان' : asset);

export const CASE_REASON_EXTRA: Record<string, string> = {
  SETTLEMENT_OUTCOME_UNKNOWN: 'نتیجه‌ی تسویه از بانک مشخص نیست',
};
export const caseReason = (c: string): string =>
  CASE_REASON[c] ?? CASE_REASON_EXTRA[c] ?? 'علت ثبت‌شده';
